import { SelectedActions } from './selected_actions'

const initialSelectedState = {
    uri: undefined,
}
export const selected = (state = { ...initialSelectedState} , action) => {
  switch (action.type) {
    case "SelectedActions.EMPTY":
      return{
        ...initialXSDState,
      };
    case "SelectedActions.SELECTED":
      return{
        ...state,
        uri: action.uri,
    };
    default:
      return state;
  }
}